import React, { useEffect } from 'react'
import About from '../components/AboutPage/About'
import Uniform from '../components/AboutPage/Uniform'
import LifeAtSkyford from '../components/AboutPage/LifeAtSkyford'

const AboutPage = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

  return (
    <div>
      <About />
      <Uniform />
      <LifeAtSkyford />
    </div>
  )
}

export default AboutPage
